import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  init() {
    gsap.registerPlugin(ScrollTrigger); 
    
    if($('.block-featured-content').length){
      var 
        blockName = '.block-featured-content',
        featCTitle = '.block-featured-content .section-title',
        featCImage = '.featured-content-card .featured-image',
        featC = '.featured-content-card',
        featuredCTl = gsap.timeline({
          scrollTrigger : {
            trigger : blockName,
            start : '-100px center',
            once : true
          }
        });
      
      gsap.set(blockName, {autoAlpha: 0});
      gsap.set(featCTitle, {autoAlpha: 0, y:100});
      gsap.set(featC, {autoAlpha:0, y:100});

      featuredCTl
        .to(blockName, {autoAlpha:1})
        .to(featCTitle, {autoAlpha:1, y:0})
        .to(featC, {autoAlpha:1, y:0});

    }
  },
  finalize() {}
}